import * as React from "react"

export type Tone = "home" | "dark" | "light"

/** Nodes of the shell that the home intro animates (same keys as Home27 uses). */
export type IntroNodes = Partial<
    Record<"logo" | "signature0" | "signature1" | "time0" | "time1" | "nav" | "navIcon", HTMLElement>
>

export type ShellState = {
    menuOpen: boolean
    setMenuOpen: (open: boolean) => void
    /** registered by the shell; read by the home intro */
    intro: React.MutableRefObject<IntroNodes>
    /** page change with the site's transition */
    navigate: (href: string) => boolean
    mobile: boolean
    /** another case of the work page is on screen: the shell takes its colours */
    caseColors: (tone: Tone, stops: number[][], progress?: () => number | null, instant?: boolean) => void
    /** the next category scrolled into view: it takes over in place (no transition) */
    continueTo: (href: string, back?: boolean) => void
}

export const ShellContext = React.createContext<ShellState | null>(null)
export const useShell = () => React.useContext(ShellContext)

/** Desktop and phone layouts switch at 768px wide (as on the Framer site). */
export const MOBILE_QUERY = "(max-width: 767.98px)"
export function useMobile() {
    const get = () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
    const [mobile, setMobile] = React.useState(get)
    React.useEffect(() => {
        const mq = window.matchMedia(MOBILE_QUERY)
        const on = () => setMobile(mq.matches)
        mq.addEventListener("change", on)
        on()
        return () => mq.removeEventListener("change", on)
    }, [])
    return mobile
}
